mutation DismissStreamKeyAlert($eventId: ID!, $seenAt: AWSDateTime!) {
  result: StreamToolsDismissStreamKeyAlert(eventId: $eventId, seenAt: $seenAt) {
    eventId
    dismissed
  }
}
